import { useEffect, useState } from "react";
import { toast } from "sonner";
import { core, useMhStream } from "@/lib/mh";
import { errText } from "@/lib/http";
import { useAuth } from "@/context/AuthContext";
import { Eyebrow } from "@/components/mh/bits";
import { ModelCard } from "@/components/mh/ModelCard";
import { RuntimeCard } from "@/components/mh/RuntimeCard";
import { ToolsCard } from "@/components/mh/ToolsCard";
import { OpenClawMapping, OpenClawSetup, OpenClawEvents } from "@/components/mh/OpenClawPanels";

export default function Connections() {
  const { isOwner, canManage, isAdmin, current } = useAuth();
  const [data, setData] = useState(null);
  const load = () => core.connections().then((r) => setData(r.data)).catch((e) => toast.error(errText(e)));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);
  useMhStream((ev) => {
    if (ev.type !== "tools.verified") return;
    if (ev.check.status === "running") setData((d) => d && { ...d, tool_check: ev.check });
    else load().then(() => ev.check.status === "done" ? toast.success("Tool check finished") : toast.error(ev.check.error || "Tool check failed"));
  });
  const toggle = async (name, connected) => {
    setData((d) => ({ ...d, tools: d.tools.map((t) => (t.name === name ? { ...t, connected, state: connected ? "declared" : "not_set", note: null } : t)) }));
    await core.setTool(name, connected).catch((e) => toast.error(errText(e)));
  };
  if (!data) return <div className="h-[50vh] grid place-items-center font-mono text-xs text-muted-foreground">Loading connections…</div>;
  return (
    <div className="max-w-[1200px] mx-auto space-y-6" data-testid="connections-page">
      <header className="mh-rise">
        <Eyebrow>{current?.name} · connections</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-3">Yours, ours, <em className="text-muted-foreground">or both.</em></h1>
        <p className="text-sm sm:text-base text-muted-foreground mt-3 max-w-2xl">Choose who supplies the AI model and who runs the agents. Each switch is separate: you can bring your own Kimi key and still run on the managed runtime.</p>
        {!isOwner && <p className="font-mono text-xs text-[#FFB020] mt-3" data-testid="connections-readonly">Only the workspace owner or agency admin can change these switches.</p>}
      </header>
      <ModelCard data={data} onSaved={setData} canEdit={isOwner} isAdmin={isAdmin} />
      <RuntimeCard data={data} onSaved={setData} canEdit={isOwner} />
      {data.runtime.mode === "own" && (
        <>
          <OpenClawEvents wsId={data.workspace_id} canEdit={isOwner} standin={data.runtime.standin} />
          <OpenClawMapping key={data.runtime.base_url} data={data} canEdit={isOwner} />
          <OpenClawSetup data={data} />
        </>
      )}
      <ToolsCard data={data} canEdit={canManage} canVerify={isOwner} onToggle={toggle} />
    </div>
  );
}
